import React from "react";
import { Radio as MuiRadio } from "@mui/material";

export const RadioButton = ({
  color = "primary",
  checked,
  onChange,
  value,
  name,
}) => <MuiRadio {...{ color, checked, onChange, value, name }} />;
